<template>
  <div id="app">
    <div class="loader-wrapper" v-if="isLoading">
      <div class="spinner spinner-1"></div>
    </div>
    <router-view></router-view>

    <Overlay></Overlay>
    <Timeout></Timeout>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Overlay from '@/components/Overlay';
import Timeout from '@/components/Timeout';
import WarningModal from '@/components/modals/WarningModal';
import vkBridge from '@vkontakte/vk-bridge';

export default {
  data() {
    return {
      warningImage: '',
      warningTitle: '',
      warningText: '',
    };
  },
  computed: {
    ...mapState(['loading', 'user']),
    isLoading() {
      return Object.entries(this.loading)
        .map((loading) => loading[1])
        .some((loading) => loading);
    },
  },
  components: {
    Overlay,
    Timeout,
    WarningModal,
  },

  beforeMount() {
    vkBridge.send('VKWebAppInit').then(() => {
      console.log('vk bridge connected');
    });
  },

  mounted() {
    if (this.$route.name !== 'success' && this.$route.name !== 'fail') {
      const cookieToken = this.$cookie.get('i');

      this.$store.dispatch('startApp', {
        cookieToken,
        startRouteName: this.$route.name,
        currency: this.$route.query.currency || '₽',
      });
    }
  },
  watch: {
    $route(to, from) {
      if (to.name !== from.name && to !== 'success') {
        this.$store.dispatch('logChangePage', { to: to.name, from: from.name });
      }
    },
  },
};
</script>

<style src="./App.scss" lang="scss"></style>
